<template>
  <div class="stepper bg-blue-50">
    <b-container fluid="xl" class="mb-4">
      <b-row class="d-none d-md-block mb-5 pb-5 mb-md-0 pb-md-0 d-none-print">
        <Logo background class="bg-white position-absolute stepper-logo"></Logo>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="pb-md-3 mb-md-2 pt-3 mt-2 d-none-print"
          :class="props.returnRoute ? '' : 'd-none d-md-block'"
          order="1"
        >
          <b-row align-h="start">
            <FormSteps v-if="props.showSteps" class="d-none d-md-block" />
            <b-col
              v-if="props.returnRoute"
              cols="12"
              lg="auto"
              align-self="center"
              class="mb-0 mb-md-0 mt-2"
            >
              <BackButton :to="props.returnRoute.to" :text="returnRoute?.text"></BackButton>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" class="mt-0 mt-md-n3 d-none-print" order="3" order-md="2">
          <slot name="title"></slot>
        </b-col>
        <b-col
          v-bind="stepperBodyCols"
          order="4"
          order-md="3"
          :md="props.narrowBody ? '8' : '12'"
          :class="{ 'mr-auto ml-auto': props.narrowBody }"
        >
          <slot name="body" v-bind:child="getChild"></slot>
        </b-col>
        <b-col
          v-if="showChildCard"
          cols="12"
          md="6"
          lg="5"
          class="mt-2 mb-n3 d-none-print"
          order="2"
          order-md="4"
        >
          <b-card
            no-body
            bg-variant="white"
            class="mb-4 border-0 mt-3 mt-md-0"
            footer-class="p-0 m-0 border-0"
            footer-bg-variant="light"
          >
            <b-card-body class="m-0 p-0 d-flex flex-column justify-content-between">
              <ChildHeader
                :firstName="getChild.first_name"
                :province="getChild.province"
                :birthyear="getChild.birthyear"
                :child-data="getChild"
                :daysWaiting="getChild.days_waiting"
              ></ChildHeader>
              <MoneyLabel class="d-none d-md-block"></MoneyLabel>
            </b-card-body>
          </b-card>
          <HelpDeskInformationBox class="mt-3 d-none d-md-block"></HelpDeskInformationBox>
        </b-col>
        <b-col v-if="showChildCard" cols="12" md="4" lg="5" class="my-2 d-none-print" order="5">
          <HelpDeskInformationBox class="mt-3 d-block d-md-none"></HelpDeskInformationBox>
        </b-col>
      </b-row>
    </b-container>
    <slot name="bottomSection" />
    <AppFooter :ovalBackground="backgroundFooter()" :show-links-on-mobile="false"></AppFooter>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import type { BackButtonProps } from '@/types'
import type { RouteRecordName } from 'vue-router'

// @ts-ignore
import { useStore } from 'vuex'

import ChildHeader from '@/components/widgets/childCard/ChildHeader.vue'
import MoneyLabel from '@/components/formOfSupport/MoneyLabel.vue'
import HelpDeskInformationBox from '@/components/widgets/HelpDeskInformationBox.vue'
import AppFooter from '@/components/global/AppFooter.vue'
import Logo from '@/components/widgets/Logo.vue'
import BackButton from '@/components/global/BackButton.vue'
import FormSteps from '@/components/widgets/FormSteps.vue'

type Props = {
  returnRoute: BackButtonProps
  narrowBody?: boolean
  showSteps?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  narrowBody: false,
  showSteps: true
})

const vuexStore = useStore()
// add ts after migrating child store to pinia
const getChild = computed(() => vuexStore.getters['child/getChild'] ?? {})

const routesWithChildCard: RouteRecordName[] = ['FormOfSupport', 'FormOfDonorData']
const route = useRoute()
const showChildCard = computed<boolean>(() => {
  return routesWithChildCard.includes(route.name)
})

const stepperBodyCols = computed(() => {
  if (showChildCard.value) {
    return {
      cols: '12',
      lg: '7',
      md: '8'
    }
  }
  return {
    cols: '12'
  }
})

const routesWithSalmonBackground: RouteRecordName[] = ['FormOfSupport']
const backgroundFooter = (): string => {
  return routesWithSalmonBackground.includes(route.name) ? 'bg-salmon-500' : 'bg-blue-50'
}
</script>
